export const getStorage = async (): Promise<
	Pick<Storage, "getItem" | "setItem" | "removeItem">
> => {
	let _getItem = (_key: string): string | null => {
		return null;
	};
	let _setItem = (_key: string, _value: string) => {};
	let _removeItem = (_key: string) => {};

	const isNode =
		typeof process !== "undefined" &&
		!!process.versions &&
		!!process.versions.node;

	if (isNode) {
		const { lmdb } = await import("../lmdb/index.ts");

		_getItem = (key) => {
			return lmdb.get(key);
		};

		_setItem = (key, value) => {
			lmdb.putSync(key, value);
		};

		_removeItem = (key) => {
			lmdb.removeSync(key);
		};
	} else if (typeof localStorage !== "undefined") {
		_getItem = (key) => {
			return localStorage.getItem(key);
		};

		_setItem = (key, value) => {
			localStorage.setItem(key, value);
		};

		_removeItem = (key) => {
			localStorage.removeItem(key);
		};
	}

	return {
		getItem: (key) => {
			return _getItem(key);
		},
		setItem: (key, value) => {
			_setItem(key, value);
		},
		removeItem: (key) => {
			_removeItem(key);
		},
	};
};
